module.exports = __webpack_public_path__ + "static/favicon-26bf290cf77388bb78f40476adc95a64.png";